<template>
  <div class="dialog-content">
    <el-dialog title="人员选择" :visible.sync="isShow" @close="onClose">
      <el-input placeholder="请输关键字搜索" v-model="keywords" @input="onSearch"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
      <div style="margin: 10px 0">可选列表</div>
      <div class="picker-cell-group" v-if="options.length>0">
        <div class="picker-cell" v-for="(item, index) in options" :v-if="index < limit" v-show="!item.hidden">
          <el-checkbox :value="item.checked" @change="toggle(item)">{{item.name}}({{''+sexName(item.sex)+' '+typeName(item.type)}})</el-checkbox>
        </div>
      </div>
      <div v-else>
        没有记录...
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Popup,
  Toast,
  Cell,
  CellGroup,
  Icon,
  Search,
  Checkbox,
  CheckboxGroup
} from "vant";

Vue.use(Popup)
  .use(Toast)
  .use(Cell)
  .use(CellGroup)
  .use(Icon)
  .use(Search)
  .use(Checkbox)
  .use(CheckboxGroup);

export default {
  name: "SubjectJiaolianPicker",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    options:{
      type: Array,
      default: () => []
    },
    defaultValue: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 1
    },

  },
  data() {
    return {
      isShow: false,
      result: [],
      resultIds: [],
      keywords: "",
    };
  },
  mounted() {
  },
  watch: {
    show(value) {
      this.isShow = value;
      let that = this;
      if(value){
       that.options.map(option =>{
         that.$set(option,'checked',false);
         that.$set(option,'hidden',false);
          that.defaultValue.map( dv =>{
            if(dv.num == option.num){
              that.$set(option,'checked',true);
            }
          })
        });

        this.result = that.options.filter(option =>{
          return option.checked;
        });

        this.resultIds = that.options.map(option =>{
          return option.id;
        })
      }
    },
    keywords(val){
      let that = this;
      console.log(val);
      this.options.filter(option =>{
        if(option.name.indexOf(val.trim()) == -1){
          that.$set(option,'hidden',true);
        }else{
          that.$set(option,'hidden',false);
        }
      });
    }
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },


    toggle(item) {
      console.log('toggle',item.checked);
      this.$set(item,'checked',item.checked);
      if(!item.checked){
        //选中
        if(this.limit ==1 ){
          //单选
          this.options.map(item=>{
            item.checked = false;
          })
          this.result = [];
          this.resultIds = [];
        }else{
          //多选
          if(this.result.length >= this.limit ){
            Toast('最多不能超过'+(this.limit)+'个');
            return ;
          }

        }

      }
      item.checked =!item.checked ;
      if(item.checked){
        //add
        this.result.push(item);
        this.resultIds.push(item.id);
      }else{
        //pen
        this.result = this.result.filter(val =>{
          return val.id != item.id
        });
        this.resultIds = this.resultIds.filter(val =>{
          return val != item.id
        });
      }
    },
    onSearch() {
      let that = this;
//      this.keywords
          that.options.map((item,index) =>{
            if(that.resultIds.indexOf(item.id) ==-1){
              item.checked = false;
            }else{
              item.checked = true;
            }
          })
          // that.options = [...res.data];
    },

    onConfirm() {
      let that = this;
      console.log(that.result);
      that.$emit("onConfirm", that.result);
      that.isShow = false;
    },


    sexName(val){
      return val==1? '男' :'女';
    },
    typeName(val){
      switch (val){
        case 1:
          return '领队';
          break;
        case 2:
          return '运动员';
          break;
        case 3:
          return '教练员';
          break;
        case 4:
          return '裁判员';
          break;
        default:
          return '随行人员'
      }
    }
  }
};
</script>

<style scoped>
.contain {
  position: relative;
}
.search-box {
  position: fixed;
  z-index: 999;
  width: 100%;
}
.van-search__content {
  background: #efeff4;
}

.user-box {
  margin-bottom: 50px;
}

.createbtn {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.cell-img {
  width: 48px;
  height: 48px;
  float: left;
  border-radius: 50%;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// SubjectJiaolianPicker.vue?26cb6073